import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { DescriptionPage_ProductVariant as DescriptionPageProductVariant } from '__generated__/graphql-types';

import { PROF_CERTS_USING_SKILL_CERT_LABEL } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

export function getCourseSyllabusTitle(numberOfModules: number) {
  return (
    <FormattedMessage
      message={_t(
        // eslint-disable-next-line
        'There {numberOfModules, plural, =1 {is {numberOfModules} module} other {are {numberOfModules} modules}} in this course'
      )}
      numberOfModules={numberOfModules}
    />
  );
}

export function getSpecializationSyllabusTitle(
  productVariant: DescriptionPageProductVariant,
  numberOfCourses: number,
  slug: string
) {
  if (
    productVariant === DescriptionPageProductVariant.ProfessionalCertificate &&
    PROF_CERTS_USING_SKILL_CERT_LABEL.includes(slug)
  ) {
    return (
      <FormattedMessage
        message={_t(
          // eslint-disable-next-line no-restricted-syntax
          'Skill Certificate - {numberOfCourses, plural, =1 {{numberOfCourses} course series} other {{numberOfCourses} course series}}'
        )}
        numberOfCourses={numberOfCourses}
      />
    );
  } else if (
    productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
    productVariant === DescriptionPageProductVariant.GoogleCertificate
  ) {
    return (
      <FormattedMessage
        message={_t(
          // eslint-disable-next-line
          'Professional Certificate - {numberOfCourses, plural, =1 {{numberOfCourses} course series} other {{numberOfCourses} course series}}'
        )}
        numberOfCourses={numberOfCourses}
      />
    );
  }
  return (
    <FormattedMessage
      message={_t(
        // eslint-disable-next-line
        'Specialization - {numberOfCourses, plural, =1 {{numberOfCourses} course series} other {{numberOfCourses} course series}}'
      )}
      numberOfCourses={numberOfCourses}
    />
  );
}
